// GameContainer.jsx
import React, { useState, useEffect } from "react";
import {
    initGame,
    generarGameStats
} from "../gameStorage";
import EventViewer from "../EventViewer";
import { useDispatch, useSelector } from "react-redux";
import { saveGameData, listenToGameData, listenToGameEvents } from "../../../../data-store/actions/teamgames-actions";
import { useParams } from "react-router-dom";
import BasketballGameDashboard from "./BasketballGameDashboard";

// TODOS
// Reporte general del evento (puntos por atleta, faltas, tiempo en cancha etc)
// en esa vista agregar perfil de anotador y perfil de coach para que el coash registre al equipo
// Link público del juego
// respaldo en local de toda la bitacora



const PublicGameContainer = () => {
    const [gameStats, setGameStats] = useState(false);

    const gameData = useSelector((state) => state.teamgames.gameData);
    const gameEvents = useSelector((state) => state.teamgames.gameEvents);

    const { gameId } = useParams();

    const dispatch = useDispatch();

    useEffect(() => {
        const unsubscribe = dispatch(listenToGameData(gameId));
        // Limpia el listener al desmontar
        return () => {
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [dispatch, gameId]);
    useEffect(() => {
        const unsubscribe = dispatch(listenToGameEvents(gameId));

        return () => {
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [dispatch, gameId]);
    useEffect(() => {
        if (gameData && gameData.estado) {
            setGameStats(generarGameStats(gameEvents, gameData));


        }
    }, [gameEvents, gameData]);

    console.log("generarResumenPorEquipo", gameStats);


    useEffect(() => {
        initGame(gameId);
    }, []);



    return (
        <div style={{ padding: 10 }}>
            {gameData && gameData.estado && gameStats &&
                <BasketballGameDashboard game={gameData} summary={gameStats} clock={gameStats.clock} />
            }
        </div>
    );
};

export default PublicGameContainer;
